import Vue from 'vue';
import Vuex from 'vuex';
import Config from '@/store/config';
import Account from '@/store/account';

Vue.use(Vuex);

const modules = {
  Config,
  Account,
};

const store = new Vuex.Store({
  modules,
});

export default store;
